import { render, staticRenderFns } from "./FzorganAdmin.vue?vue&type=template&id=65592fe3&scoped=true&"
import script from "./FzorganAdmin.vue?vue&type=script&lang=js&"
export * from "./FzorganAdmin.vue?vue&type=script&lang=js&"
import style0 from "./FzorganAdmin.vue?vue&type=style&index=0&id=65592fe3&scoped=true&lang=css&"
import style1 from "./FzorganAdmin.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65592fe3",
  null
  
)

export default component.exports